import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Spinner } from 'react-bootstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DataTables from '../commonComponent/DataTable/DataTables';
import NoRecordFounds from '../commonComponent/DataTable/NoRecordFounds';
import axios from 'axios';
import { URL_Start } from '../../../constant';
import SweetAlert from 'sweetalert2';
import paginationFactory from 'react-bootstrap-table2-paginator';
import EditToolTip from '../UI/ToolTips/EditToolTip';
import ToolTip from '../commonComponent/ToolTip';
import LoadingButton from '../commonComponent/LoadingButton';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { set } from 'lodash';
import { Navigate } from 'react-big-calendar';
import { useHistory } from 'react-router';
import { saveAs } from 'file-saver';
export const ApproveDebitCreditNote = () => {
  const history = useHistory();
    const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isrejectLoading, setIsRejectLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [crntPageNO, setCrntPageNO] = useState(0);
  const [showbutton, setShowButton] = useState(false);
  const [typeSelected, setTypeSelected] = useState([]);
  const [defaultfromDate, setDefaultFromDate] = useState("");
  const [defaulttoDate, setDefaultToDate] = useState("");
  const [checkedRows, setCheckedRows] = useState({});
  const [isRejectReport, setIsRejectReport] = useState(false);
  const [selectedTrDCNRAID, setSelectedTrDCNRAID] = useState([]);
   const abortControllerRef = useRef(null);
  let rejectreason = useRef();
  let fromDate = useRef();
  let toDate = useRef();
  var glblArr = [];

  useEffect(() => {
    const today = new Date();
    const todate = new Date(today).toISOString().split('T')[0];
    const sevenDaysBefore = new Date();
    sevenDaysBefore.setDate(today.getDate() - 7);
    const fromdate = new Date(sevenDaysBefore).toISOString().split('T')[0];

    setDefaultFromDate(fromdate);
    setDefaultToDate(todate);
    BindGrid(fromdate, todate, "1");
  }, []);

  const actionFormatter = (cellData, rowData, rowIndex, extraData) => {
    return <React.Fragment>
      <div>
        {
          rowData.OrderStatus.toLowerCase() === "pending" && rowData.ARights === "True"  ?
            <>
              <input className="checkbox_animated" type="checkbox" onClick={(e) => { handleEditCheckbox(e, rowData); }} />
              <ToolTip title="View Approver" placement="top" linkId={`Edit${rowData.VisitingId}`} onClick={() => editHandler(rowData.TrDCNRAID, "1", "-1")} faName="fa fa-pencil mr-2"></ToolTip>
            </>
            :
            null
        }
        &nbsp;&nbsp;
        {
            //<ToolTip title="View Details" placement="top" linkId={`Bill${rowData.VisitingId}`} onClick={() => Printreceipt(rowData.VisitingId)} faName="fa fa-eye"></ToolTip>
            <ToolTip title="View Details" placement="top" linkId={`Bill${rowData.VisitingId}`} onClick={() => editHandler(rowData.TrDCNRAID, "2", "-1")} faName="fa fa-eye"></ToolTip>
        }
      </div>
    </React.Fragment>
  }

  const editHandler = async (TrDCNRAID, SetType, Isapprove) => {
    const encryptString = window.btoa(`id=${TrDCNRAID}&type=${SetType}&Isaprrove=${Isapprove}`);
    if (SetType == "1") {
    window.location.href = `${process.env.PUBLIC_URL}/accounts/DrCrapproveamount?${encryptString}`;
    //history.push(`${process.env.PUBLIC_URL}/accounts/DrCrapproveamount?${encryptString}`);
    // const popup = window.open(`${process.env.PUBLIC_URL}/accounts/DrCrapproveamount?${encryptString}`, "_blank");
    // window.top.close(false);

    // const timer = setInterval(() => {
    //   if (popup.closed) {
    //     clearInterval(timer);
    //     window.location.reload(); // Refresh parent
    //   }
    // }, 500);
    }
    else if (SetType == "2") {
      const popup = window.open(`${process.env.PUBLIC_URL}/accounts/DrCrapproveamountView?${encryptString}`, "_blank");
      window.top.close(false);
      //history.push({ pathname: `${process.env.PUBLIC_URL}/accounts/DrCrapproveamountView?${encryptString}` });
    }
  };
    const handleOpenDebitCreditNote = async (TrDCNRAID) => {
    //const encryptString = window.btoa(`id=${TrDCNRAID}&type=${SetType}&Isaprrove=${Isapprove}`);
    // const popup = window.open(`${process.env.PUBLIC_URL}/accounts/RequestDebitCreditNote`, "_blank");
    // window.top.close(false);

    // const timer = setInterval(() => {
    //   if (popup.closed) {
    //     clearInterval(timer);
    //     window.location.reload(); // Refresh parent
    //   }
    // }, 500);
    history.push({ pathname: `${process.env.PUBLIC_URL}/accounts/RequestDebitCreditNote`});
  };

    const handleEditCheckbox = (e, rawData) => {
    console.log(rawData);
    const checked = e.target.checked;
    if (checked) {
      glblArr.push({
        TrDCNRAID: rawData.TrDCNRAID
      })
      setSelectedTrDCNRAID(glblArr);
    }
    else {
      glblArr = glblArr.filter((d) => d.TrDCNRAID != rawData.TrDCNRAID)
      setSelectedTrDCNRAID(glblArr);
    }
    if (glblArr.length == 0) { setShowButton(false); }
    else { setShowButton(true); }
  };

    const Printreceipt = (vId) => {
    if (vId == "0" || vId == "") { }
    else {
      localStorage.removeItem('vId');
      localStorage.setItem('vId', vId);
      window.open(`${process.env.PUBLIC_URL}/admin/receipt`, '_blank');
    }
  }

  const columns = [
    { dataField: '#', text: '#', editable: false, formatter: (cellData, rowData, rowIndex) => <span>{crntPageNO + rowIndex + 1}</span>, headerStyle: () => ({ width: '2%' }) },
    { dataField: '', text: 'Action', formatter: actionFormatter, editable: false, headerStyle: (colum, colIndex) => { return { width: '10%' }; } },
    { dataField: 'Name', text: 'Customer', editable: false },
    { dataField: 'InvoiceID', text: 'Invoice No', editable: false, formatter: (cell, row) => {
                return (
                    <span
                        onClick={() => Printreceipt(row.VisitingID || row.VistingID)}
                        style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                    >
                        {cell}
                    </span>
                );
            } },
    { dataField: 'DrCrNoteNo', text: 'Note No', editable: false },
    { dataField: 'DrCrType', text: 'Type', editable: false },
    { dataField: 'TotalAmount', text: 'Total Amount', editable: false },
    { dataField: 'AppliedName', text: 'Added By', editable: false },
    { dataField: 'AppliedDate', text: 'Added Date', editable: false },
    { dataField: 'OrderStatus', text: 'Approval Status', editable: false },
    { dataField: 'ReportDisplay', text: 'Report Display', editable: false }
  ];

  const BindGrid = async (fromdate, todate, flag) => {
    if (fromdate > todate) {
      SweetAlert.fire("From date should not be greater than to date");
      toDate.current.value = defaulttoDate;
      return false;
    }
    setIsLoading(true);
    let url = URL_Start + 'accounts/GetDebitCreditNoteApprovedList/ ' + localStorage.getItem('LoggedInUser') + '/'+flag+'/0/' + fromdate + '/' + todate;
    await axios.get(url).then((response) => {
      const data = response.data;
      if (data.Success && data.Data) {
        let filtered = [];
        if (flag === "1") filtered = data.Data.filter((d) => d.OrderStatus.toLowerCase() === "pending");
        else if (flag === "2") filtered = data.Data.filter((d) => d.OrderStatus.toLowerCase() === "rejected");
        else if (flag === "3") filtered = data.Data.filter((d) => d.OrderStatus.toLowerCase() === "approved");
        else filtered = data.Data;
        setTableData(filtered);
      } else {
        setTableData([]);
      }
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  };

  const handleTypeRadioChange = (e) => {
    let flag = e.target.value;
    BindGrid(fromDate.current.value, toDate.current.value, flag);
  };

  const paginationOptions = {
    sizePerPage: 50,
    showTotal: false,
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    onPageChange: (page, sizePerPage) => { setCrntPageNO(((page - 1) * sizePerPage)); }
  };

  const CallFunction = (AppRejFlag) => {
    if (AppRejFlag == "1") { handleSave("1"); }
    else { openRejectModal(); }
  }

  const handleSave = async (AppRejFlag) => {
    console.log("Selected TrDCNRAID:", JSON.stringify(selectedTrDCNRAID));
    if (selectedTrDCNRAID.length == 0) {
      SweetAlert.fire("Please select atleast one debit credit note to approve");
      return false;
    }
    if ((rejectreason.current == undefined || rejectreason.current == null || rejectreason.current.value == "") && AppRejFlag == "2") {
      SweetAlert.fire("Please provide a reason for rejection.");
      return false;
    }
    const requestOptions = {
      CreatedBy: localStorage.LoggedInUser,
      TrDCNRAID: JSON.stringify(selectedTrDCNRAID),
      flag: AppRejFlag,
      reasontext: rejectreason.current == undefined || rejectreason.current == null || rejectreason.current == "" ? "" : rejectreason.current.value
    };
    if (AppRejFlag == "1") { setIsLoading(true); }
    if (AppRejFlag == "2") { setIsRejectLoading(true); }
    try {
      const url = URL_Start + 'accounts/ApproveRejectDrCrNote';
      await axios.post(url, requestOptions).then((response) => {
        const data = response.data;
        if (data.Success) {
          if (AppRejFlag == "1") {
            setIsLoading(false);
            SweetAlert.fire({ title: 'Approve', text: data.ErrorList[0].errorMsg, icon: 'success', confirmButtonText: 'Ok', reverseButtons: true })
              .then((result) => {
                if (result.value) { glblArr = []; setShowButton(false); window.location.reload(false); }
                else { glblArr = []; setShowButton(false); window.location.reload(false); }
              })
          }
          if (AppRejFlag == "2") {
            setIsRejectLoading(false);
            SweetAlert.fire({ title: 'Reject', text: data.ErrorList[0].errorMsg, icon: 'success', confirmButtonText: 'Ok', reverseButtons: true })
              .then((result) => {
                if (result.value) { glblArr = []; setShowButton(false); window.location.reload(false); }
                else { glblArr = []; setShowButton(false); window.location.reload(false); }
              })
          }
        }
        else {
          if (AppRejFlag == "1") { setIsLoading(false); }
          if (AppRejFlag == "2") { setIsRejectLoading(false); }
          if (data.Data == "-2001") { SweetAlert.fire("JSON value is incorrect, Contact support team"); }
          else if (data.Data == "-2000" || data.Data == "-6") { SweetAlert.fire("Runtime error occured, Check db logs"); }
          else if (response.data.ErrorList[0].errorCode === "-1998") {
              SweetAlert.fire("Error", "Refund request has already been applied or approved.", "error");
          }
          else if (response.data.ErrorList[0].errorCode === "-2013") {
              SweetAlert.fire("Error", "Insufficient balance", "error");
          }
          else if (data.Data == "-2011" || data.Data == "-2012") {
            SweetAlert.fire({ title: 'Data already saved', text: 'Please refresh page', icon: 'warning', confirmButtonText: 'Ok', reverseButtons: true })
              .then((result) => {
                if (result.value) { window.location.reload(false); }
                else { window.location.reload(false); }
              });
          }
          else { SweetAlert.fire({ title: "Application Exception", text: "Some error occured! Please try after sometime", icon: "error" }); }
          setSelectedTrDCNRAID([]);
          //setIsRejectReport(false);
        }
      }).catch(function (error) {
        if (AppRejFlag == "1") { setIsLoading(false); }
        if (AppRejFlag == "2") { setIsRejectLoading(false); }
        if (error.response) { ErrorFunction(error.response.status); }
      });
    } catch (error) {
      if (AppRejFlag == "1") { setIsLoading(false); }
      if (AppRejFlag == "2") { setIsRejectLoading(false); }
      SweetAlert.fire({ title: "Server Inaccessible!", text: "You may not be connected to a network or Unable to connect to a server", icon: "error" });
    }
    setSelectedTrDCNRAID([]);
  }

  const openRejectModal = () => { setIsRejectReport(!isRejectReport); }

    const ErrorFunction = async (ErrorCode) => {
      if (ErrorCode == "400")
        SweetAlert.fire({ title: "Error 400", text: "Bad request", icon: "error" })
      else if (ErrorCode == "401")
        SweetAlert.fire({ title: "Error 401", text: "Unauthorized", icon: "error" })
      else if (ErrorCode == "403")
        SweetAlert.fire({ title: "Error 403", text: "Forbidden", icon: "error" })
      else if (ErrorCode == "404")
        SweetAlert.fire({ title: "Error 404", text: "Page not found", icon: "error" })
      else if (ErrorCode == "500")
        SweetAlert.fire({ title: "Error 500", text: "Internal Server Error", icon: "error" })
      else if (ErrorCode == "503")
        SweetAlert.fire({ title: "Error 503", text: "Service Unavailable", icon: "error" })
    }


//   const handleDownload_csv = async (f) => {

//     if (!fromDate.current.value || !toDate.current.value) {
//         alert('Please select both from and to dates.');
//         return;
//     }


//     const userId = localStorage.getItem('LoggedInUser');
//     if (!userId) {
//         alert('User not logged in. Please log in first.');
//         return;
//     }

//     //setIsLoading(true);
    
//     try {
//         const url = `${URL_Start}accounts/DownloadCsvDebitCreditNote/${userId}/4/0/${fromDate.current.value}/${toDate.current.value}`;
        
//         console.log("Downloading from:", url);
        
//         const response = await axios.get(url, { 
//             responseType: 'blob',
//             headers: {
//                 'Accept': 'text/csv'
//             },
//             timeout: 30000 // 30 second timeout
//         });

//         if (!response.data || response.data.size === 0) {
//             throw new Error('Empty response received');
//         }

//         if (response.data.type && response.data.type.includes('json')) {
//             const text = await response.data.text();
//             const errorData = JSON.parse(text);
//             throw new Error(errorData.message || 'Server returned an error');
//         }

//         const blob = new Blob([response.data], { type: 'text/csv' });
        
//         const fileName = `DebitCreditNote_${new Date().toISOString().split('T')[0]}.csv`;
//         saveAs(blob, fileName);
        
//         console.log('CSV downloaded successfully');
        
//     } catch (error) {
//         console.error('Error downloading CSV file:', error);
        
//         if (error.code === 'ECONNABORTED') {
//             alert('Request timeout. Please try again.');
//         } else if (error.response) {
//             const status = error.response.status;
            
//             switch (status) {
//                 case 404:
//                     alert('No records found for the specified date range.');
//                     break;
//                 case 500:
//                     alert('Server error occurred. Please contact support.');
//                     break;
//                 case 401:
//                     alert('Unauthorized. Please log in again.');
//                     break;
//                 default:
//                     if (error.response.data instanceof Blob) {
//                         try {
//                             const text = await error.response.data.text();
//                             alert(text || 'Failed to download CSV file.');
//                         } catch {
//                             alert('Failed to download CSV file. Please try again.');
//                         }
//                     } else {
//                         alert('Failed to download CSV file. Please try again.');
//                     }
//             }
//         } else if (error.request) {
//             alert('Network error. Please check your internet connection.');
//         } else {
//             alert(error.message || 'An unexpected error occurred.');
//         }
//     } finally {
//         //setIsLoading(false); // Hide loading indicator
//     }
// };


const handleDownload_csv = async (f) => {
        // Create new AbortController for this download
        abortControllerRef.current = new AbortController();
        
        if (!fromDate.current.value || !toDate.current.value) {
            alert('Please select both from and to dates.');
            return;
        }

        const userId = localStorage.getItem('LoggedInUser');
        if (!userId) {
            alert('User not logged in. Please log in first.');
            return;
        }

        //setIsLoading(true);
        
        try {
            const url = `${URL_Start}accounts/DownloadCsvDebitCreditNote/${userId}/4/0/${fromDate.current.value}/${toDate.current.value}`;
            
            console.log("Downloading from:", url);
            
            const response = await axios.get(url, { 
                responseType: 'blob',
                headers: {
                    'Accept': 'text/csv'
                },
                timeout: 300000,
                signal: abortControllerRef.current.signal // Use ref here
            });

            if (!response.data || response.data.size === 0) {
                throw new Error('Empty response received');
            }

            if (response.data.type && response.data.type.includes('json')) {
                const text = await response.data.text();
                const errorData = JSON.parse(text);
                throw new Error(errorData.message || 'Server returned an error');
            }

            const blob = new Blob([response.data], { type: 'text/csv' });
            
            const fileName = `DebitCreditNote_${new Date().toISOString().split('T')[0]}.csv`;
            saveAs(blob, fileName);
            
            console.log('CSV downloaded successfully');
            
        } catch (error) {
            // Handle cancellation
            if (axios.isCancel(error) || error.name === 'CanceledError') {
                console.log('Download cancelled');
                return;
            }
            
            console.error('Error downloading CSV file:', error);
            
            if (error.code === 'ECONNABORTED') {
                alert('Request timeout. Please try again.');
            } else if (error.response) {
                const status = error.response.status;
                
                switch (status) {
                    case 404:
                        alert('No records found for the specified date range.');
                        break;
                    case 500:
                        alert('Server error occurred. Please contact support.');
                        break;
                    case 401:
                        alert('Unauthorized. Please log in again.');
                        break;
                    default:
                        if (error.response.data instanceof Blob) {
                            try {
                                const text = await error.response.data.text();
                                alert(text || 'Failed to download CSV file.');
                            } catch {
                                alert('Failed to download CSV file. Please try again.');
                            }
                        } else {
                            alert('Failed to download CSV file. Please try again.');
                        }
                }
            } else if (error.request) {
                alert('Network error. Please check your internet connection.');
            } else {
                alert(error.message || 'An unexpected error occurred.');
            }
        } finally {
            //setIsLoading(false);
            abortControllerRef.current = null; // Clear reference
        }
    };
const handleCancel = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }
  };





  return (
    <React.Fragment>
      <Breadcrumb title="Debit Credit Note" parent="Accounts" />
      <Container fluid>
        <Row>
          <Col md={12}>
            <Card>
              <Card.Header className='pb-0'>
                <Card.Title>Debit Credit Note List</Card.Title>
              </Card.Header>
              <Card.Body>
                <Form.Group className='animate-chk m-checkbox-inline center__type mt-15'>
                  <Form.Label htmlFor="pending">
                    <input className="radio_animated" type="radio" id='pending' name="rdoo-ani" defaultChecked onChange={handleTypeRadioChange} value='1' />Pending
                  </Form.Label>
                  <Form.Label htmlFor="approved">
                    <input className="radio_animated" type="radio" id='approved' name="rdoo-ani" onChange={handleTypeRadioChange} value='3' />Approved
                  </Form.Label>
                  <Form.Label htmlFor="rejected">
                    <input className="radio_animated" type="radio" id='rejected' name="rdoo-ani" onChange={handleTypeRadioChange} value='2' />Rejected
                  </Form.Label>
                  <Form.Label htmlFor="all">
                    <input className="radio_animated" type="radio" id='all' name="rdoo-ani" onChange={handleTypeRadioChange} value='4' />All
                  </Form.Label>
                </Form.Group>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>From Date</Form.Label>
                      <Form.Control type="date" id="date1" name="date1" ref={fromDate} defaultValue={defaultfromDate} max={defaulttoDate} onChange={handleTypeRadioChange} />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>To Date</Form.Label>
                      <Form.Control type="date" id="date2" name="date2" ref={toDate} defaultValue={defaulttoDate} max={defaulttoDate} onChange={handleTypeRadioChange} />
                    </Form.Group>
                  </Col>
                  <Col md={6} className='text-right' >
                    {/* <Form.Group >
                      <Button variant='primary' type='submit' className="mr-2" onClick={() => handleOpenDebitCreditNote("2")}>Add Debit Credit Note</Button>
                    </Form.Group> */}
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>

                  </Col>
                  <Col md={2} className='text-right' >
                    <Form.Group >
                      <Button variant='primary' type='submit' className="mr-2" onClick={() => handleOpenDebitCreditNote("2")}>Add Debit Credit Note</Button>
                    </Form.Group>
                  </Col>
                  <Col md={2} className='text-right' >
                    <Form.Group >
                      <Button variant='primary' type='submit' className="mr-2" onClick={() => handleDownload_csv()}>Download</Button>
                      {/* <Button onClick={() => handleCancel()}>Cancel Download</Button> */}
                    </Form.Group>
                  </Col>
                </Row>
                {isLoading ?
                  <div className='text-center'> <Spinner animation="border" size='sm' /></div> :
                  <DataTables
                    keyField='TrDCNRAID'
                    tableData={tableData}
                    columns={columns}
                    noDataIndication={<NoRecordFounds />}
                    pagination={paginationFactory(paginationOptions)}
                  />
                }
                {
                  showbutton &&
                  <Col md={12} className='text-center __center__buttonsec'>
                    {
                      isLoading ?
                        <LoadingButton variantName='primary' cssName="" /> :
                        <>
                          <Button variant='primary' className="mr-2" onClick={() => {
                                                                          SweetAlert.fire({
                                                                          title: "Are you sure?",
                                                                          text: "Would you like to approve selected debit/credit note ?",
                                                                          icon: "warning",
                                                                          showCancelButton: true,
                                                                          confirmButtonColor: "#3085d6",
                                                                          cancelButtonColor: "#d33",
                                                                          confirmButtonText: "Yes, approve it!",
                                                                          }).then((result) => {
                                                                          if (result.isConfirmed) {
                                                                              CallFunction("1");
                                                                          }
                                                                          });
                                                                      }} >Approve Selected</Button>
                        </>
                    }
                    {
                      isrejectLoading ?
                        <LoadingButton variantName='primary' cssName="" /> :
                        <>
                          <Button variant='secondary' className="mr-2" onClick={() => CallFunction("2")} >Reject Selected</Button>
                        </>
                    }
                  </Col>
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={isRejectReport} toggle={openRejectModal} centered={true}>
        <ModalHeader toggle={openRejectModal}>Reject reason</ModalHeader>
        <ModalBody>
          <Form.Row className='justify-content-left mt-4'>
            <Col md={12} lg={12}>
              <Form.Group>
                <Form.Label>Reject reason <span className='text-red'>* (250 characters allowed)</span></Form.Label>
                <Form.Control as="textarea" rows={3} name="refundreason" maxLength={250} ref={rejectreason} />
              </Form.Group>
            </Col>
            <Col md={12} className='text-center'>
              {isSaving ?
                <LoadingButton variantName='primary' cssName="mr-2" /> :
                <>
                  <Button variant='primary' type='submit' className="mr-2" onClick={() => {
                                                                          SweetAlert.fire({
                                                                          title: "Are you sure?",
                                                                          text: "Would you like to reject selected debit/credit note ?",
                                                                          icon: "warning",
                                                                          showCancelButton: true,
                                                                          confirmButtonColor: "#3085d6",
                                                                          cancelButtonColor: "#d33",
                                                                          confirmButtonText: "Yes, reject it!",
                                                                          }).then((result) => {
                                                                          if (result.isConfirmed) {
                                                                              handleSave("2")
                                                                          }
                                                                          });
                                                                      }} >Reject</Button>
                </>
              }
            </Col>
          </Form.Row>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default ApproveDebitCreditNote;